export default "__VITE_ASSET__ES9bSti8__"